
import Vue from 'vue'
import {
  VCard,
  VList,
  VListItem,
  VListItemContent,
  VListItemGroup,
  VListItemTitle,
} from 'vuetify/lib'
import dayjs from 'dayjs'
import { maxRange } from '@/components/jcdc/JcdcDatePicker.vue'

export default Vue.extend({
  name: 'JcdcDateRanges',
  components: {
    VCard,
    VList,
    VListItemGroup,
    VListItem,
    VListItemContent,
    VListItemTitle,
  },
  props: {
    current: { type: Boolean, default: false },
    last: { type: Boolean, default: false },
    pyRange: { type: Number, default: 0 },
    rolling: { type: Boolean, default: false },
    activeDateRange: { type: String, default: '' },
    maxRange: { type: Object as () => maxRange, default: undefined },
  },
  data() {
    return {
      model: -1,
      dateRanges: {},
      dateValues: [] as string[],
    }
  },
  watch: {
    activeDateRange() {
      this.model = this.dateValues.indexOf(this.activeDateRange)
    },
  },
  beforeMount() {
    this.updateRanges()
  },
  beforeUpdate() {
    this.updateRanges()
  },
  methods: {
    updateRanges() {
      const daysInYear = 365,
        daysInMonth = 31,
        daysInWeek = 7,
        maxRangeValue = this.maxRange?.value ? this.maxRange.value : 1,
        maxRangeDays = this.maxRange
          ? this.maxRange.unit == 'year' || this.maxRange.unit == 'y'
            ? daysInYear * maxRangeValue
            : this.maxRange.unit == 'month' || this.maxRange.unit == 'M'
            ? daysInMonth * maxRangeValue
            : this.maxRange.unit == 'week' || this.maxRange.unit == 'w'
            ? daysInWeek * maxRangeValue
            : this.maxRange.unit == 'day' || this.maxRange.unit == 'd'
            ? maxRangeValue
            : 0
          : '',
        yearTest = this.maxRange ? maxRangeDays >= daysInYear : true,
        monthTest = this.maxRange ? maxRangeDays >= daysInMonth : true,
        weekTest = this.maxRange ? maxRangeDays >= daysInWeek : true

      this.dateRanges = {}

      // Include current Rolling PY
      if (this.rolling && yearTest) {
        this.dateRanges['Rolling Year'] = [dayjs().subtract(1, 'year'), dayjs()]
      }
      // Include current and previous PYs
      if (this.pyRange > 0 && yearTest) {
        // Constants
        const currentYear = dayjs().year(),
          currentPY =
            dayjs().month() < 6
              ? dayjs().subtract(1, 'year').year()
              : currentYear,
          currentPYStart = dayjs(new Date(currentPY, 6, 1)),
          currentPYEnd = dayjs(new Date(currentPY + 1, 5, 30))
        // Functions
        this.dateRanges[
          `PY ${
            currentPY == currentYear ? '' : `${currentPY.toString()}`
          } to Date `
        ] = [dayjs(currentPYStart), dayjs()]
        for (let i = 1; i < this.pyRange; i++) {
          const keyName = `PY ${(currentPY - i).toString()}`
          this.dateRanges[keyName] = [
            dayjs(currentPYStart).subtract(i, 'year'),
            dayjs(currentPYEnd).subtract(i, 'year'),
          ]
        }
      }
      // Include current week/month/year
      if (this.current) {
        if (weekTest) {
          this.dateRanges['This Week'] = [
            dayjs().startOf('week'),
            dayjs().endOf('week'),
          ]
        }
        if (monthTest) {
          this.dateRanges['This Month'] = [
            dayjs().startOf('month'),
            dayjs().endOf('month'),
          ]
        }
        if (yearTest) {
          this.dateRanges['This Year'] = [
            dayjs().startOf('year'),
            dayjs().endOf('year'),
          ]
        }
      }
      // Include last week/month/year
      if (this.last) {
        if (weekTest) {
          this.dateRanges['Last Week'] = [
            dayjs().subtract(1, 'week').startOf('week'),
            dayjs().subtract(1, 'week').endOf('week'),
          ]
        }
        if (monthTest) {
          this.dateRanges['Last Month'] = [
            dayjs().subtract(1, 'month').startOf('month'),
            dayjs().subtract(1, 'month').endOf('month'),
          ]
        }
        if (yearTest) {
          this.dateRanges['Last Year'] = [
            dayjs().subtract(1, 'year').startOf('year'),
            dayjs().subtract(1, 'year').endOf('year'),
          ]
        }
      }
      // Create an array of date strings
      const tempArray: Array<string[]> = Object.values(this.dateRanges)
      this.dateValues = tempArray.map((a: string[]) =>
        a.map((b) => dayjs(b).format('MM/DD/YYYY')).join(' - ')
      )
      this.model = this.dateValues.indexOf(this.activeDateRange)
    },
  },
})
